import axios from 'axios';
import {
  FETCH_ADVERTISER_DATE_QUARTER,
  FETCH_WOW_REQUEST,
  FETCH_WOW_DATE_ERROR,
  FETCHED_WOW_REPORT,
  FETCHED_WOW_REPORT_ERROR,
  RESET_WOW_DATA
} from './wowTypes';
import { getMultipleQuartersDateRange } from '../../utils/quarterUtils';

import BASE_URL from '../config';
axios.defaults.timeout = 120000;
const timeout = 120000;
const wowTimeout = 600000; // 10 minutes for WoW
export const fetchRequest = () => {
  return {
    type: FETCH_WOW_REQUEST,
    payload: []
  };
};
export const resetWowData = () => {
  return {
    type: RESET_WOW_DATA,
    payload: []
  };
};
export const fetchRequestWow = (msg) => {
  return {
    type: FETCH_WOW_REQUEST,
    payload: [msg]
  };
};

export const fetchWowAdvertiserQuarters = () => (dispatch, getState) => {
  const state = getState();
  const currentQuarters = state.wowReducer.advertiser_quarters || [];
  const advertiserId = localStorage.getItem('advertiserId') || '';
  const sfId = localStorage.getItem('sfId') || '';
  const payload = {
    userEmail: state.userReducer.userEmail,
    advertiser_id: advertiserId,
    sfId,
    startDate: state.campaignReducer.start_date,
    endDate: state.campaignReducer.end_date,
    timeZone: state.advertiserReducer.timeZone
  };

  // optional debug
  console.log('fetchWowAdvertiserQuarters - request payload:', payload);

  return axios({
    method: 'post',
    url: `${BASE_URL}/getWowAdvertiserQuarter`,
    headers: { 'Content-Type': 'application/json' },
    data: payload,
    timeout
  })
    .then((response) => {
      const quartersFromApi = (response.data && response.data.quarters) || [];

      // Normalize to array of strings (if API returns objects adjust accordingly)
      // Assuming quartersFromApi is an array of strings like "2024_Q1"
      if (!Array.isArray(quartersFromApi)) {
        console.warn('Unexpected quarters payload', quartersFromApi);
        return dispatch(fetchWowQuartersFailure('No quarters found'));
      }

      // create stable signature for comparison
      const newSignature = quartersFromApi.join(',');
      const currentSignature = (currentQuarters || []).join(',');

      // If nothing changed: do NOT dispatch - prevents re-trigger loops
      if (newSignature === currentSignature) {
        console.log('fetchWowAdvertiserQuarters - quarters unchanged, skipping dispatch');
        return Promise.resolve(); // nothing to do
      }

      if (quartersFromApi.length > 0) {
        const quarters = quartersFromApi;
        const { startDate, endDate } = getMultipleQuartersDateRange(quarters);

        console.log('🔍 Auto-calculated WoW dates:', { quarters, startDate, endDate });

        // Dispatch quarters only if changed
        dispatch(fetchWowQuarters(quarters));
        dispatch({ type: 'SET_WOW_START_DATE', payload: startDate });
        dispatch({ type: 'SET_WOW_END_DATE', payload: endDate });

        return Promise.resolve();
      } else {
        return dispatch(fetchWowQuartersFailure('No quarters found'));
      }
    })
    .catch((error) => {
      console.error('fetchWowAdvertiserQuarters error', error?.response || error);
      // defensive: if response exists and 404 show 'No Data Found'
      if (error?.response?.data?.statusCode === 404) {
        dispatch(fetchWowQuartersFailure('No Data Found'));
      } else {
        dispatch(fetchWowQuartersFailure('Not able to fetch data. Please retry'));
      }
      return Promise.reject(error);
    });
};

export const fetchWowReportNonSkanData = (campaign_list) => (dispatch, getState) => {
  dispatch(fetchRequestWow('loading'));
  axios({
    method: 'post',
    url: `${BASE_URL}/getNonSkanWowReport`,
    header: {
      'Content-Type': 'application/json'
    },
    data: {
      userEmail: getState().userReducer.userEmail,
      CampaignIds: campaign_list,
      advertiser_id: localStorage.getItem('advertiserId'),
      sfId: localStorage.getItem('sfId'),
      startDate: getState().campaignReducer.start_date,
      endDate: getState().campaignReducer.end_date,
      timeZone: getState().advertiserReducer.timeZone,
      wow_quarters: getState().wowReducer.selected_advertiser_wow_quarters
    },
    timeout: wowTimeout
  })
    .then((response) => {
      console.log(response.data);
      if (response.data.length > 0) {
        return dispatch(fetchedWowReportDetails(response.data));
      } else {
        return dispatch(fetchWowReportFailure('Sorry no data found'));
      }
    })
    .catch(function (error) {
      //console.log("Show error notification!", error, error.response);
      return dispatch(fetchWowReportFailure('Not able to fetch data. Please try again'));
      //return Promise.reject(error)
    });
};
export const fetchWowReportSkanData = (campaign_list) => (dispatch, getState) => {
  dispatch(fetchRequestWow('loading'));

  const requestData = {
    userEmail: getState().userReducer.userEmail,
    CampaignIds: campaign_list,
    advertiser_id: localStorage.getItem('advertiserId'),
    sfId: localStorage.getItem('sfId'),
    startDate: getState().campaignReducer.start_date,
    endDate: getState().campaignReducer.end_date,
    timeZone: getState().advertiserReducer.timeZone,
    wow_quarters: getState().wowReducer.selected_advertiser_wow_quarters
  };

  console.log('🔍 fetchWowReportSkanData - Request data:', requestData);
  console.log('🔍 fetchWowReportSkanData - Wow quarters:', getState().wowReducer.selected_advertiser_wow_quarters);

  axios({
    method: 'post',
    url: `${BASE_URL}/getSkanWowReport`,
    header: {
      'Content-Type': 'application/json'
    },
    data: requestData,
    timeout: wowTimeout
  })
    .then((response) => {
      //console.log(response.data.raweventdata)
      if (response.data.length > 0) {
        return dispatch(fetchedWowReportDetails(response.data));
      } else {
        return dispatch(fetchWowReportFailure('Sorry no data found'));
      }
    })
    .catch(function (error) {
      //console.log("Show error notification!", error, error.response);
      return dispatch(fetchWowReportFailure('Not able to fetch data. Please try again'));
      //return Promise.reject(error)
    });
};
export const fetchWowQuarters = (data) => {
  //console.log('data', data);
  // Call the function with your JSON data
  //const detectedKeys = detectKeys(data);
  //console.log("detectedKeys",detectedKeys)
  const wowDetails = data.map((item, id = index) => ({ id, ...item }));
  //console.log('wowDetails', data);
  return {
    type: FETCH_ADVERTISER_DATE_QUARTER,
    payload: data
  };
};
export const fetchWowQuartersFailure = (error) => {
  return {
    type: FETCH_WOW_DATE_ERROR,
    payload: error
  };
};
function detectKeys(jsonData) {
  const keys = new Set();

  jsonData.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      keys.add(key);
    });
  });
  return Array.from(keys);
}
export const fetchedWowReportDetails = (data) => {
  // Call the function with your JSON data
  //console.log(data);
  const detectedKeys = detectKeys(data);
  ////console.log("detectedKeys",detectedKeys)
  const rawEventData = data.map((item, id = index) => ({ id, ...item }));
  const sortedData = data.sort((a, b) => {
    if (a.year === b.year) {
      return parseInt(a.week_number) - parseInt(b.week_number);
    }
    return parseInt(a.year) - parseInt(b.year);
  });
  //console.log('sortedData', sortedData);
  // console.log("rawEventData",rawEventData)
  return {
    type: FETCHED_WOW_REPORT,
    payload: rawEventData
  };
};

export const fetchWowReportFailure = (error) => {
  return {
    type: FETCHED_WOW_REPORT_ERROR,
    payload: error
  };
};
